import { compose, lifecycle } from 'recompose';

import { connect } from 'react-redux';
import {
  actions as orderActions,
  selectors as orderSelectors,
} from 'state/order';

import MRForm from 'components/form/MRForm/component';

const enhance = compose(
  connect(
    (state) => ({
      shipmentKeys: orderSelectors.getShipmentKeys(state),
    }),
    {
      setDefaults: orderActions.setDefaults,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { setDefaults } = this.props;
      setDefaults();
    },
  })
);

export default enhance(MRForm);
